export const gallusTheater = {
  id: "gallus-theater",
  disciplines: "Corporate Design",
  year: 2021,
  project: "Gallus Theater",
  initiatedAt: "HfG Gmünd, DE (Bachelor)",
  shortInitiatedAt: "HfG, DE (BA)",
  thumbnailUrl: "/assets/Gallus/00-G-1x1.webp",
  description:
    "The visual identity is built around a modular star system derived from the abstraction of a spotlight, combined with a color system assigning distinct tones to each program focus. The design translates the theater’s progressive and experimental character into a flexible identity across print, digital applications, and augmented reality posters that actively involve the audience.",
  credits: [
    "Initiated at BA Communication Design, Hochschule für Gestaltung Gmünd, Germany",
    "Mentoring Roman Heinrich; Student Team Nikola John, Lisa Amann",
  ],
  galleryItems: [
    {
      medias: [
        {
          type: "image",
          url: "/assets/Gallus/01-G-16x9-2560.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-twelve-lg landscape-media-sixteen-by-nine",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Gallus/02-G-1x1-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-four-lg square-media-one-by-one",
        },
        {
          type: "image",
          url: "/assets/Gallus/03-G-1x1-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-seven-lg span-six-lg square-media-one-by-one",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Gallus/04-G-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-six-lg portrait-media-nine-by-ten",
        },
        {
          type: "image",
          url: "/assets/Gallus/05-G-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-seven-lg span-six-lg portrait-media-nine-by-ten",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "video",
          sound: true,
          url: "/assets/Gallus/06-G-16x9.mp4",
          poster: "/assets/Gallus/06-G-16x9_thumbnail.mp4",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-twelve-lg landscape-media-sixteen-by-nine",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Gallus/07-G-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-six-lg portrait-media-nine-by-ten",
        },
        {
          type: "image",
          url: "/assets/Gallus/08-G-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-seven-lg span-six-lg portrait-media-nine-by-ten",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
  ],
};
